"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var React = require("react");
var react_hot_toast_1 = require("react-hot-toast");
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var config_action_1 = require("../../../../actions/config_action");
var api_service_1 = require("../../../../api/api_service");
var button_component_1 = require("../../../../common/buttons/button_component");
var pop_up_1 = require("../../../../common/modal/pop-up");
var react_paginate_1 = require("../../../../common/react_pagination/react_paginate");
var AGgrid_table_component_1 = require("../../../../common/tables/AGgrid_table_component");
var appConstants_1 = require("../../../../constants/appConstants");
var route_path_1 = require("../../../../constants/route_path");
var table_data_1 = require("../../../../constants/table_data");
var menu_constants_1 = require("../../../../menuList/menu_constants");
var array_helpers_1 = require("../../../../utils/array_helpers");
var IntracityGraphList = function (_a) {
    var lifeCycleList = _a.lifeCycleList, totalCount = _a.totalCount, totalPageCount = _a.totalPageCount, setpageCount = _a.setpageCount, pageCount = _a.pageCount, errorMsgGraphList = _a.errorMsgGraphList, selectedEvent = _a.selectedEvent, startDate = _a.startDate, endDate = _a.endDate, labCode = _a.labCode, labList = _a.labList, event = _a.event;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_1.useNavigate)();
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var PageLimit = 50;
    var navigateToMyReports = function () {
        dispatch((0, config_action_1.featchCurrentActiveMenu)({
            mainModule: menu_constants_1.FEATURE_CONSTANTS.reports,
            subModule: menu_constants_1.FEATURE_CONSTANTS.sub_my_reports,
            subChaildModule: '',
            subGroupModule: ''
        }));
        navigate("/".concat(route_path_1.default.PATHS.MYREPORTS));
    };
    var handlePageClick = function (data) {
        var currentPage = data.selected + 1;
        setpageCount(currentPage);
    };
    var autoGenerateReportHandler = function () {
        var payload = {};
        if (startDate && endDate) {
            var dateRangeArr = {
                start_date: moment(startDate).format('YYYY-MM-DD'),
                end_date: moment(endDate).format('YYYY-MM-DD'),
            };
            payload['date_range'] = dateRangeArr;
        }
        if (labCode.length > 0) {
            var selectedlabCode = (0, array_helpers_1.selecteAllOption)(labCode, labList);
            payload['lab_code'] = selectedlabCode;
        }
        if (selectedEvent != null) {
            payload['type'] = selectedEvent;
        }
        if (event) {
            payload['interval'] = (0, array_helpers_1.convertIntracityXaxis)(event);
        }
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.Intracity_graph_download,
            payLoad: payload,
            domain: process.env.APPROVAL_BASEURL,
        })
            .then(function (res) {
            if (res.data.statusCode === 200) {
                setOpen(true);
            }
            else {
                react_hot_toast_1.default.error(res.data.message);
            }
        })
            .catch(function (err) {
            react_hot_toast_1.default.error(err.data.errors);
        });
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "mid-page-heaidng" },
            React.createElement("h2", { className: "F-18" }, "Intracity-TAT"),
            React.createElement(button_component_1.default, { type: "button", buttonName: appConstants_1.reportDownload, color: "yellow-outline", endIcon: "icon-import download-icon", isError: lifeCycleList && (lifeCycleList === null || lifeCycleList === void 0 ? void 0 : lifeCycleList.length) > 0 ? false : true, onClickHandler: autoGenerateReportHandler })),
        React.createElement("div", { className: "unclickablerow custom-pagination-table" },
            React.createElement(AGgrid_table_component_1.default, { isSortable: true, columnDefs: table_data_1.default.INTRACITY_TAT_SAMPLE_LIST_COLUMNS, rows: lifeCycleList, pagination: false, enableCellTextSelection: true, className: 'bagging-lifecycle-table intracity-pagination', errorMessage: errorMsgGraphList }),
            React.createElement(react_paginate_1.default, { onPageChange: handlePageClick, pageCount: totalPageCount, currentPage: pageCount, total: totalCount, dataLength: lifeCycleList === null || lifeCycleList === void 0 ? void 0 : lifeCycleList.length, currentPageLimits: PageLimit })),
        React.createElement(pop_up_1.default, { open: open },
            React.createElement("div", { className: "modal-header" },
                React.createElement("h2", { className: "heading" }, "Request Submitted"),
                React.createElement("h2", { className: "sub-heading" }, "Please view your report in My Reports section")),
            React.createElement("div", { className: "modal-footer sticky-modal-footer" },
                React.createElement(button_component_1.default, { buttonName: "Cancel", color: "yellow-outline", isError: false, onClickHandler: function () { return setOpen(false); } }),
                React.createElement(button_component_1.default, { buttonName: "My Reports", color: "yellow", onClickHandler: navigateToMyReports, isError: false })))));
};
exports.default = IntracityGraphList;
